module.exports = __webpack_public_path__ + "img/girls-two.33378bc7.png";